import { Section } from '../../components/Section/Section';
import { HighLightedText } from '../../components/HighLightedText/HighLightedText';
import { Alert, AlertTitle, Box, Button, Container } from '@mui/material';
import React from 'react';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { InformationPage } from '../../components/Page/InformationPage';

export default function AlgemeneVoorwaardenPage() {
  return (
    <InformationPage
      title="Lees onze kristalheldere algemene voorwaarden."
      selectedTab={1}
      seo={{
        description:
          'De algemene voorwaarden van AppCenter Nederland BV zijn van toepassing op alle producten en diensten. Hiervoor maken wij gebruik van de NL Digital Voorwaarden 2020. De voorwaarden zijn door NLdigital gedeponeerd bij de Rechtbank Midden-Nederland, locatie Utrecht. Bij het afnemen van de producten en diensten gaat de afnemer automatisch akkoord met de voorwaarden.',
        openGraph: {
          type: 'website',
          locale: 'nl_NL',
          title:
            'Lees onze kristalheldere algemene voorwaarden. | AppCenter Nederland',
          description:
            'De algemene voorwaarden van AppCenter Nederland BV zijn van toepassing op alle producten en diensten. Hiervoor maken wij gebruik van de NL Digital Voorwaarden 2020. De voorwaarden zijn door NLdigital gedeponeerd bij de Rechtbank Midden-Nederland, locatie Utrecht. Bij het afnemen van de producten en diensten gaat de afnemer automatisch akkoord met de voorwaarden.',
          images: [
            {
              url: 'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              secureUrl:
                'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              width: 1920,
              height: 1080,
              alt: 'De algemene voorwaarden van AppCenter Nederland BV zijn van toepassing op alle producten en diensten. Hiervoor maken wij gebruik van de NL Digital Voorwaarden 2020. De voorwaarden zijn door NLdigital gedeponeerd bij de Rechtbank Midden-Nederland, locatie Utrecht. Bij het afnemen van de producten en diensten gaat de afnemer automatisch akkoord met de voorwaarden.',
              type: 'image/jpeg',
            },
          ],
          site_name: 'AppCenter Nederland',
        },
      }}
    >
      <Section1 />
    </InformationPage>
  );
}

function Section1() {
  return (
    <Section
      position={'center'}
      subtitle={
        'De algemene voorwaarden van AppCenter Nederland BV zijn van toepassing op alle producten en diensten. Hiervoor maken wij gebruik van de NL Digital Voorwaarden 2020. De voorwaarden zijn door NLdigital gedeponeerd bij de Rechtbank Midden-Nederland, locatie Utrecht. Bij het afnemen van de producten en diensten gaat de afnemer automatisch akkoord met de voorwaarden.'
      }
      caption={'Weet precies waar je aan toe bent.'}
      title={
        <>
          Lees onze kristalheldere{' '}
          <HighLightedText
            TypographyProps={{ color: 'secondary' }}
            text={'algemene'}
          />{' '}
          <HighLightedText
            text={'voorwaarden.'}
            TypographyProps={{ color: 'secondary' }}
          />
        </>
      }
    >
      <Box sx={{ textAlign: 'center' }}>
        <Button
          size={'large'}
          variant={'contained'}
          href={
            'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/nl_digital_voorwaarden_acn.pdf'
          }
          target={'_blank'}
          endIcon={<RemoveRedEyeIcon />}
        >
          Bekijk NL Digital voorwaarden
        </Button>
      </Box>
      <Box mt={4} />
      <Container maxWidth={'md'}>
        <Alert
          severity="info"
          sx={{
            backgroundImage:
              'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))',
            backgroundColor: '#05123b',
          }}
        >
          <AlertTitle>Transparantie</AlertTitle>
          Deze Algemene Voorwaarden zijn voor het laatst geüpdatet op{' '}
          <strong>23-08-2022</strong>
        </Alert>
      </Container>
    </Section>
  );
}
